<mat-form-field class="py-2 px-3" appearance="outline" subscriptSizing="dynamic">
  <mat-label>{{ 'field.search' | translate }}</mat-label>
  <input matInput (keyup)="onSearch($event)" />
  <mat-icon matSuffix>search</mat-icon>
</mat-form-field>
<span class="grey-text f-12" *ngIf="items().length > 500">
  <mat-icon class="s-icon v-middle material-icons-outlined">info</mat-icon>
  {{ 'page.items.kamishibai.tooManyItemsMessage' | translate }}
</span>
<div cdkDropListGroup class="kanban-board d-flex flex-nowrap gx-0 pb-3 px-2">
  @for (group of groups(); track kanbanColumns()[idx]; let idx = $index) {
    <div class="w-100">
      <div class="kanban-column mx-2">
        <div class="header {{ kanbanColumns()[idx] }}">
          <mat-icon *ngIf="kanbanColumns()[idx] === 'todo'">adjust</mat-icon>
          <mat-icon *ngIf="kanbanColumns()[idx] === 'inProgress'">schedule</mat-icon>
          <mat-icon *ngIf="kanbanColumns()[idx] === 'done'">task_alt</mat-icon>
          <span>
            {{ 'system.label.' + kanbanColumns()[idx] | translate }}
            {{ group.length ? '(' + group.length + ')' : '' }}
          </span>
        </div>
        <div
          cdkDropList
          [id]="boardColumnIdPrefix + kanbanColumns()[idx]"
          [cdkDropListData]="group"
          class="scw-kanban-list"
          (cdkDropListDropped)="drop($event)"
        >
          @for (item of group; track item.id) {
            <div class="mb-3 kanban-item" cdkDrag [cdkDragData]="item">
              <app-item-card
                class="item-card"
                [item]="{
                  assigneeName: item.assignee,
                  createdAt: item.createdAt,
                  key: item.itemKey,
                  name: item.title,
                  id: item.id,
                  itemTypeName: item.itemType,
                  itemCategoryName: item.itemCategory,
                  itemType: item.boardItemConfiguration.itemType,
                  itemCategory: item.boardItemConfiguration.itemCategory?.name,
                  dueDate: item.dueDate.original,
                  statusCategory: kanbanColumns()[idx],
                  titleIcon: item.titleIcon,
                  boardId: item.boardId,
                }"
                (cardClick)="openItemEditModal(item.id, item.itemKey, item.boardKey)"
                (triggerRefreshData)="triggerRefreshData()"
              ></app-item-card>
            </div>
          }
        </div>
      </div>
    </div>
  }
</div>
